import axios from 'axios';
import type { Content } from '#layers/core/app/runtime/services/StorageService';

export class AiCoreImageMetadataService
{
    private static getUrl()
    {
        const config = useRuntimeConfig();

        return config.public.localApiUrl;
    }

    private static getAuthHeader()
    {
        const { $auth } = useAuth();

        return { Authorization: `Bearer ${$auth.token()}` };
    }

    public static async genImageMetadata(params: {
        provider: string;
        owner: string;
        name: string;
    }, body: { imagePublicId: string }): Promise<Record<string, Content>>
    {
        return (await axios.post<Record<string, Content>>(`${this.getUrl()}/aicore/image-metadata`, body, { params, headers: this.getAuthHeader() })).data;
    }
}

export default AiCoreImageMetadataService;
